import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import DatePicker from "react-datepicker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "react-datepicker/dist/react-datepicker.css";
import { removeChildContract } from "../../../redux/actions/contractActions";
let rand = require("random-key");

import Attributes from "./Attributes";

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  incrementalRedemption = [],
  maxAsGift = [],
  vouchers = [];


class AdditionalPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateOption: this.props.affiliateOption,
      indexKey: this.props.indexKey,
      attributeStatus: false,
      attributes: "",
      priceData: this.props.priceData ? this.props.priceData : "",
      disable: false,
      incRed: 0,
      monthdisable: false,
    };

    expirationMonth[this.props.indexKey] = "";
    expirationDate[this.props.indexKey] = "";
    incrementalRedemption[this.props.indexKey] = "0";
  }

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };

  componentDidMount() {}

  componentWillMount() {
    if (this.state.priceData == "") {
      offerTitle[this.state.indexKey] = "";
      expirationMonth[this.state.indexKey] = "";
      minQuantity[this.state.indexKey] = "";
      skuCode[this.state.indexKey] = "";
      maxPerCustomer[this.state.indexKey] = "";
      maxAvailable[this.state.indexKey] = "";
      retailPrice[this.state.indexKey] = "";
      offerPrice[this.state.indexKey] = "";
      remittance[this.state.indexKey] = "";
      incrementalRedemption[this.state.indexKey] = "";
      maxAsGift[this.state.indexKey] = "";
    }
  }

  componentWillReceiveProps(nextProps) {}

  removePriceDetail = e => {
    if (this.state.priceData) {
      let getContractID = e.target.attributes.getNamedItem("data-key").value;
      this.props.removeChildContract(getContractID);
    }
    this.props.removePriceDetail(this.state.indexKey);
  };

  handleOfferChange = e => {
    offerTitle[this.state.indexKey] = e.target.value;
    this.props.handleOfferChange(e.target.value, this.state.indexKey);
  };

  handleexpirationMonthChange = e => {
    expirationMonth[this.state.indexKey] = e.target.value;
    if (expirationMonth[this.state.indexKey] != "") {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }
    this.props.handleexpirationMonthChange(e.target.value, this.state.indexKey);
  };

  handleexpirationDateChange = e => {
    expirationDate[this.state.indexKey] = e.target.value;
    if (expirationDate[this.state.indexKey] != "") {
      this.setState({ monthdisable: true });
    } else {
      this.setState({ monthdisable: false });
    }
    this.props.handleexpirationDateChange(e.target.value, this.state.indexKey);
  };

  handleminQuantityChange = e => {
    minQuantity[this.state.indexKey] = e.target.value;
    this.props.handleminQuantityChange(e.target.value, this.state.indexKey);
  };

  handleskuCodeChange = e => {
    skuCode[this.state.indexKey] = e.target.value;
    this.props.handleskuCodeChange(e.target.value, this.state.indexKey);
  };

  handlemaxPerCustomerChange = e => {
    maxPerCustomer[this.state.indexKey] = e.target.value;
    this.props.handlemaxPerCustomerChange(e.target.value, this.state.indexKey);
  };

  handlemaxAvailableChange = e => {
    maxAvailable[this.state.indexKey] = e.target.value;
    this.props.handlemaxAvailableChange(e.target.value, this.state.indexKey);
  };

  handleretailPriceChange = e => {
    retailPrice[this.state.indexKey] = e.target.value;
    this.props.handleretailPriceChange(e.target.value, this.state.indexKey);
  };

  handleofferPriceChange = e => {
    offerPrice[this.state.indexKey] = e.target.value;
    this.props.handleofferPriceChange(e.target.value, this.state.indexKey);
  };

  handleremittanceChange = e => {
    remittance[this.state.indexKey] = e.target.value;
    this.props.handleremittanceChange(e.target.value, this.state.indexKey);
  };

  handleincrementalRedemptionChange = e => {
    incrementalRedemption[this.state.indexKey] = e.target.value;
    this.props.handleincrementalRedemptionChange(
      e.target.value,
      this.state.indexKey
    );
    this.setState({incRed: e.target.value});
  };

  handleGenerateVoucher = e => {
    vouchers[this.state.indexKey] = e.target.value;
    this.props.handleGenerateVoucher(
      e.target.value,
      this.state.indexKey
    );
  };

  handlemaxAsGiftChange = e => {
    maxAsGift[this.state.indexKey] = e.target.value;
    this.props.handlemaxAsGiftChange(e.target.value, this.state.indexKey);
  };

  attributeData = (data, idx) => {
    if (this.props.priceData) {
      this.props.handleUpdate("attributes", data, this.state.indexKey);
    } else {
      this.props.attributeData(data, this.state.indexKey);
    }
  };

  matrixData = (data, idx) => {
    if (this.props.priceData) {
      this.props.handleUpdate("metrix", data, this.state.indexKey);
    } else {
      this.props.matrixData(data, this.state.indexKey);
    }
  };

  handleUpdate = e => {
    if (e.target.name == "expirationMonth") {
      if (e.target.value == "") {
        this.setState({ disabled: false });
      }
    }
     
    this.props.handleUpdate(e.target.name, e.target.value, this.state.indexKey);
  };


  render() {
    console.log(this.state.monthdisable)
    return (
      <Row key={this.state.indexKey}>
        <div className="col-lg-12 add-sub-admin">
          {/**start contract price information **/}
          <div className="panel">
            <header className="panel-heading">
              Pricing Detail{" "}
              <Button
                bsSize="small"
                bsStyle="danger"
                className="pull-right"
                data-key={
                  this.state.priceData ? this.state.priceData.contractID : ""
                }
                onClick={this.removePriceDetail}
              >
                Remove
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Offer Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          offerTitle[this.state.indexKey]
                            ? offerTitle[this.state.indexKey]
                            : this.props.priceData.offerTitle
                        }
                        placeholder="Offer Title"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleOfferChange
                        }
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <FormGroup controlId="formExpirationMonth">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> How Long Until Purchased Vouchers Expire?
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.expirationMonthError }}
                        name="expirationMonth"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleexpirationMonthChange
                        }
                        defaultValue={this.props.priceData.expirationMonth}
                        defaultValue={expirationMonth[this.state.indexKey]}
                        disabled={this.state.monthdisable}
                      >
                        <option value="">None</option>
                        <option value="1">1 Months</option>
                        <option value="2">2 Months</option>
                        <option value="3">3 Months</option>
                        <option value="4">4 Months</option>
                        <option value="5">5 Months</option>
                        <option value="6">6 Months</option>
                        <option value="7">7 Months</option>
                        <option value="8">8 Months</option>
                        <option value="9">9 Months</option>
                        <option value="10">10 Months</option>
                        <option value="11">11 Months</option>
                        <option value="12">12 Months</option>
                        <option value="18">18 Months</option>
                        <option value="0">Never Expires</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formExpirationDate">
                      <ControlLabel>or</ControlLabel>

                      <FormControl
                        className="form-control datepicker"
                        type="date"
                        style={{ borderColor: this.state.expirationDateError }}
                        defaultValue={moment(
                          expirationDate[this.state.indexKey]
                        ).format("YYYY-MM-DD")}
                        defaultValue={this.props.priceData.expirationDate}
                        placeholder="MM-DD-YYYY"
                        onChange={this.handleexpirationDateChange}
                        name="expirationDate"
                        disabled={this.state.disabled}
                      />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>Minimum Quantity Required</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          placeholder="Minimum Quantity Required"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleminQuantityChange
                          }
                          name="minQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                          defaultValue={
                            minQuantity[this.state.indexKey]
                              ? minQuantity[this.state.indexKey]
                              : this.props.priceData.minQuantity
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        SKU #
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formSkuCode">
                        <FormControl
                          type="text"
                          placeholder="SKU Code"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleskuCodeChange
                          }
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                          defaultValue={
                            skuCode[this.state.indexKey]
                              ? skuCode[this.state.indexKey]
                              : this.props.priceData.skuCode
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max Per Customer
                        (leave blank for an unlimited amount)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMaxPerCustomer">
                        <FormControl
                          type="number"
                          placeholder="Max Per Customer"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlemaxPerCustomerChange
                          }
                          name="maxPerCustomer"
                          style={{
                            borderColor: this.state.maxPerCustomerError
                          }}
                          defaultValue={
                            maxPerCustomer[this.state.indexKey]
                              ? maxPerCustomer[this.state.indexKey]
                              : this.props.priceData.maxPerCustomer
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Maximum Available
                    </ControlLabel>
                    <FormGroup controlId="formMaxAvailable">
                      <FormControl
                        type="number"
                        placeholder="Maximum Available"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handlemaxAvailableChange
                        }
                        name="maxAvailable"
                        style={{ borderColor: this.state.maxAvailableError }}
                        defaultValue={
                          maxAvailable[this.state.indexKey]
                            ? maxAvailable[this.state.indexKey]
                            : this.props.priceData.maxAvailable
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Retail Price
                    </ControlLabel>
                    <FormGroup controlId="formRetailPrice">
                      <FormControl
                        type="number"
                        placeholder="Retail Price"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleretailPriceChange
                        }
                        name="retailPrice"
                        style={{ borderColor: this.state.retailPriceError }}
                        defaultValue={
                          retailPrice[this.state.indexKey]
                            ? retailPrice[this.state.indexKey]
                            : this.props.priceData.retailPrice
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Offer Price
                    </ControlLabel>
                    <FormGroup controlId="formOfferPrice">
                      <FormControl
                        type="number"
                        placeholder="Offer Price"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleofferPriceChange
                        }
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                        defaultValue={
                          offerPrice[this.state.indexKey]
                            ? offerPrice[this.state.indexKey]
                            : this.props.priceData.offerPrice
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          placeholder="Remittance Per Unit"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleremittanceChange
                          }
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                          defaultValue={
                            remittance[this.state.indexKey]
                              ? remittance[this.state.indexKey]
                              : this.props.priceData.remittance
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                          Will this offer generate multiple vouchers?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="incrementalRedemption"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleincrementalRedemptionChange
                          }
                          defaultValue={
                            this.props.priceData.incrementalRedemption
                              ? this.props.priceData.incrementalRedemption
                              : incrementalRedemption[this.state.indexKey]
                          }
                          // defaultValue={
                          //   incrementalRedemption[this.state.indexKey] ? incrementalRedemption[this.state.indexKey] : this.props.priceData.incrementalRedemption
                          // }
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    ) : null}

                    {(this.state.incRed == '1' || this.props.priceData.incrementalRedemption == '1') &&
                    <FormGroup>
                      <ControlLabel>Number of Vouchers to Generate Per Order (each voucher will reflect the retail price divided by the number below. A $25 order / 5 vouchers = $5 value each)</ControlLabel>
                      <FormControl
                        type="number"
                        defaultValue={this.props.priceData ? this.props.priceData.vouchers : vouchers[this.state.indexKey]}
                        placeholder="Enter Voucher Value"
                        onChange={this.props.priceData
                              ? this.handleUpdate
                              : this.handleGenerateVoucher
                            }
                        name="vouchers"
                      />
                    </FormGroup>
                    }
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max As Gifts (Do
                        not leave blank. Add 0 for no additional vouchers. No
                        unlimited option)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMaxAsGift">
                        <FormControl
                          type="number"
                          placeholder="Max As Gifts"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlemaxAsGiftChange
                          }
                          name="maxAsGift"
                          style={{ borderColor: this.state.maxAsGiftError }}
                          defaultValue={
                            maxAsGift[this.state.indexKey]
                              ? maxAsGift[this.state.indexKey]
                              : this.props.priceData.maxAsGift
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                  </Col>
                </Row>
                  {/* {!this.state.attributeStatus &&
                  isEmpty(this.state.priceData.attribute) ? (
                    <Button
                      bsSize="small"
                      onClick={this.AttributeStatus}
                      bsStyle="success"
                    >
                      Add Additional Price
                    </Button>
                  ) : ( */}
                    <Row>
                      <Col md={12} xs={12}>
                        <Attributes
                          indexKey={this.state.indexKey}
                          attributeData={this.attributeData}
                          postAttributes={this.state.priceData.attribute}
                          matrixData={this.matrixData}
                          postMatrix={this.state.priceData.metrix}
                        />
                      </Col>
                    </Row>
                  {/* )} */}
               
              </div>
            </div>
          </div>
          {/**end contract price information **/}
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    deletedContract: state.contractReducer.deletedContract,
    error: state.contractReducer.error
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { removeChildContract })
)(AdditionalPrice);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/AdditionalPrice.js